var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "label-width": "115px",
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          selection: _vm.selection,
        },
        on: {
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                [
                  _c(
                    "el-col",
                    { attrs: { span: _vm.colSpan } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "BusinessStockSearch.header.warehouseCode"
                            ),
                            prop: "warehouseCode",
                          },
                        },
                        [
                          _c("BjInput", {
                            attrs: {
                              maxlength: _vm.MAX_LENGTH.DEFAULT,
                              placeholder: _vm.$t(
                                "BusinessStockSearch.header.warehouseCode"
                              ),
                              clearable: "",
                            },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.handleQuery.apply(null, arguments)
                              },
                            },
                            model: {
                              value: _vm.queryParams.warehouseCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParams, "warehouseCode", $$v)
                              },
                              expression: "queryParams.warehouseCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: _vm.colSpan } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "BusinessStockSearch.header.warehouseId"
                            ),
                            prop: "warehouseId",
                          },
                        },
                        [
                          _c("BjSelectWarehouse", {
                            attrs: {
                              placeholder: _vm.$t(
                                "BusinessStockSearch.header.warehouseId"
                              ),
                              multiple: "",
                            },
                            model: {
                              value: _vm.queryParams.warehouseId,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParams, "warehouseId", $$v)
                              },
                              expression: "queryParams.warehouseId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("BusinessStockSearch.header.skuCode"),
                          prop: "skuCode",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.DEFAULT,
                            placeholder: _vm.$t(
                              "BusinessStockSearch.header.skuCode"
                            ),
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.skuCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "skuCode", $$v)
                            },
                            expression: "queryParams.skuCode",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "BusinessStockSearch.header.categoryIdList"
                          ),
                          prop: "categoryIdList",
                        },
                      },
                      [
                        _c("BjGoodsTypeTreeSelect", {
                          attrs: {
                            placeholder: _vm.$t(
                              "BusinessStockSearch.header.categoryIdList"
                            ),
                            multiple: "",
                          },
                          model: {
                            value: _vm.queryParams.categoryIdList,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "categoryIdList", $$v)
                            },
                            expression: "queryParams.categoryIdList",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "BusinessStockSearch.header.warehouseTypeCode"
                          ),
                          prop: "warehouseTypeCode",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            placeholder: _vm.$t(
                              "BusinessStockSearch.header.warehouseTypeCode"
                            ),
                            multiple: "",
                            "lov-code": "STOCK.WAREHOUSE_TYPE",
                          },
                          model: {
                            value: _vm.queryParams.warehouseTypeCode,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryParams,
                                "warehouseTypeCode",
                                $$v
                              )
                            },
                            expression: "queryParams.warehouseTypeCode",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "BusinessStockSearch.header.exceedZero"
                          ),
                          prop: "exceedZero",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            placeholder: _vm.$t(
                              "BusinessStockSearch.header.exceedZero"
                            ),
                            "constant-key": "STATUS_YES_TRUE",
                          },
                          model: {
                            value: _vm.queryParams.exceedZero,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "exceedZero", $$v)
                            },
                            expression: "queryParams.exceedZero",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    false
                                      ? void 0
                                      : col.prop === "stockNum"
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              (
                                                scope.row.stockNum -
                                                scope.row.lockNum
                                              ).toFixed(0)
                                            )
                                          ),
                                        ])
                                      : col.prop === "typeCode"
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$store.state.values.STOCK_WAREHOUSE_TYPE.bjGet(
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ])
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                scope.row[col.prop],
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            align: "center",
                          },
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }